var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VinWidgetBarGraphTemplate',{attrs:{"vid":"widget-avg-fuel-econ-btn","rows":_vm.rows,"graph-data":_vm.graphData,"formatter":{
    type: 'fuel',
    unit: 'econ',
  },"title":`${_vm.$t('AVG')} ${_vm.$t('Fuel Economy')}`,"timestamp":_vm.generatedAt,"fetching":_vm.isFetching,"text-suffix":"efficient","invert":_vm.fuelEcoDeltaStatus,"has-fuel-econ":"","pack-has-report":_vm.packHasReport},on:{"cta-action":_vm.navToReport,"bust-cache":function($event){return _vm.fetchData(true)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }